import React from 'react';

const ReturnSummaryInfo = ({ groupReturnReason, fgHeldDisplay }) => {
  return (
    <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 mb-4 space-y-1">
      <p className="text-sm">
        <span className="font-medium">Return Reason:</span> {groupReturnReason}
      </p>
      {fgHeldDisplay && (
        <p className="text-sm">
          <span className="font-medium">Customer held:</span> {fgHeldDisplay}
        </p>
      )}
    </div>
  );
};

export default ReturnSummaryInfo; 